import { Outlet } from '@tanstack/react-router'
import NewHeader from "@/components/new-ui/header";
import { Sidebar, SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import SidebarDetail from '@/components/Sidebar';
import Background from '@/components/new-ui/background';
import { themeStore } from '@/stores/theme-store';
import { useStore } from '@tanstack/react-store';
import { useEffect, useState } from 'react';
import { Drawer, DrawerContent } from '@/components/ui/drawer'
import { Button } from '@/components/ui/button';
import { CalendarIcon, XIcon } from 'lucide-react';
import PersianCalendar from '@/components/persian-calendar';
import DateConverter from '@/components/date-converter';
import { Separator } from '@radix-ui/react-separator';


export default function NewLayout() {
    const { theme } = useStore(themeStore)
    const [toolsDrawer, setToolsDrawer] = useState(false)


    useEffect(() => {
        if (theme === 'dark') {
            document.body.classList.add('dark')
        } else {
            document.body.classList.remove('dark')
        }
    }, [theme])

    return <>

        <div className="w-full min-h-screen overflow-x-hidden">

            <Drawer open={toolsDrawer} direction='left' onOpenChange={setToolsDrawer} fixed closeThreshold={0}>
                <DrawerContent
                    disableTop
                    className='text-right left-2 top-2 bottom-2 right-auto p-5 w-[320px] mt-auto rounded-r-xl rounded-t-none overflow-y-auto overflow-x-hidden' style={{ '--initial-transform': 'calc(100% + 8px)' } as React.CSSProperties}>
                    <div className='flex justify-between items-center mb-4'>
                        <p className='text-xl'>تقویم</p>

                        <Button variant="ghost" size="icon" onClick={() => setToolsDrawer(false)}>
                            <XIcon />
                        </Button>
                    </div>
                    <PersianCalendar />
                    <Separator className='my-2' />
                    <p className='text-xl'>تبدیل تاریخ</p>
                    <DateConverter />
                </DrawerContent>
            </Drawer>

            <div onClick={() => setToolsDrawer(true)} className='bg-card z-50 left-0 top-1/2 fixed p-2 rounded-r-2xl'>
                <CalendarIcon />
            </div>

            <SidebarProvider>
                <Sidebar side="right" collapsible="icon" className='bg-white'>
                    <SidebarDetail isNew />
                </Sidebar>
                <SidebarInset className='bg-[#EDEDED] dark:bg-[#1C2433] p-2 lg:p-10'>
                    <Background />
                    <NewHeader />
                    <div className='z-10 w-full h-full'>

                        <Outlet />
                    </div>
                </SidebarInset>
            </SidebarProvider>
        </div>
    </>
}